let parsedData = null;
  
window.onload = () => {

  document.getElementById('error__checkout__foundation').style.display = 'none';
  
  document.getElementById('checkout__purpose').addEventListener('change', (e) => { 
    
    changePurpose(e.target.value) 
  
  });

  if (document.getElementsByName("checkout")) {

    [...document.getElementsByName("checkout")].map((button) => {

      button.addEventListener('click', (e) => {
    
        validateFoundation(e);
        
      });
    
    });
    
  };
  
  const csvFile = document.getElementById('cart_foundations').value;
  
  fetch(csvFile)
    .then((response) => response.text())
    .then((csvData) => {
      // Use PapaParse to parse the CSV data
      parsedData = Papa.parse(csvData, { header: true });

      let aux = '',
          options = '<option selected value="none">Elige un propósito</option>';

      parsedData.data.map((row) => {          
        if (aux !== row['Propósito'])
          options = options + '<option value=\"' + row['Propósito'] + '\">' + row['Propósito'] + '</option>';

        aux = row['Propósito'];
      });

      document.getElementById('checkout__purpose').innerHTML = options;
    })
    .catch((error) => console.error(error));
  
};

const changePurpose = (purpose) => {

  const foundations = parsedData.data.filter((row) => {
    
    if (purpose === row['Propósito'])
      return true;

    return false;
    
  });

  let options = foundations.reduce((aux, row) =>
        aux + '<option value=\"' + row['Fundación'] + '\">' + row['Fundación'] + '</option>', 
          '<option selected value="none">Elige una fundación</option>');

  document.getElementById('checkout__foundation').innerHTML = options;
  
};

const validateFoundation = (e) => {

  document.getElementById('error__checkout__foundation').style.display = 'none';

  if (document.getElementById('checkout__foundation').selectedIndex === 0)
    document.getElementById('checkout__foundation').value = 'none';

  // let isError = false;

  // if (document.getElementById('checkout__foundation').selectedIndex === 0) {

  //   isError = true;          
  //   document.getElementById('error__checkout__foundation').innerHTML = '¡Debes elegir una fundación!';
  //   document.getElementById('error__checkout__foundation').style.display = 'block';
    
  // }

  // if (isError) {
          
  //   e.preventDefault();
  //   return;
    
  // }

  e.target.form.submit();
  
};